<div style="padding: 20px;">
    <h2 mat-dialog-title style="margin:0;">Aplicar cupom aos livros e kits</h2>

    <div mat-dialog-content style="overflow: inherit;">
        <div class="header-row">
            <mat-checkbox [checked]="selectAll" (change)="toggleSelectAll($event)">
                Selecionar todos ({{ countSelected() }} / {{ totalKits() }})
            </mat-checkbox>
        </div>

        <div class="book-list" *ngIf="!isLoading; else loadingTpl">
            <div class="book-card" *ngFor="let bv of list">
                <div class="book-header">
                    <div class="book-title">{{ bv.bookTitle }}</div>
                    <mat-checkbox [checked]="isAllSelected(bv)" [indeterminate]="isPartialSelected(bv)"
                        (change)="toggleAllForBook(bv, $event.checked)">
                        Todos os kits
                    </mat-checkbox>
                </div>

                <div class="kits">
                    <label class="kit" *ngFor="let k of bv.kits">
                        <mat-checkbox [(ngModel)]="k.selected" (change)="onKitChange()"></mat-checkbox>
                        <span>{{ k.kitName }}</span>
                    </label>
                </div>
            </div>

            <p class="note">
                Dica: por padrão todos os livros e kits ficam selecionados. Desmarque os que **não** devem aceitar este
                cupom.
            </p>
        </div>

        <ng-template #loadingTpl>
            <div class="loading">Carregando...</div>
        </ng-template>
    </div>
    <mat-dialog-actions class="action-buttons">
        <button class="back-btn" (click)="close()">Cancelar</button>
        <button class="continue-btn" (click)="save()">Salvar</button>
    </mat-dialog-actions>
</div>